var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notFound mt-5 pt-5"},[_c('div',{staticClass:"mt-5 pt-5"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("الصفحة غير موجودة !")]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.goToHome()}}},[_vm._v("العودة للصفحة الرئيسية")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }